import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Svg } from '../../1_Atoms/Svg/Svg';
import { languageController } from '../../../controllers/language/languageController';

export const FormStepsNav = ({
  navList,
  currentStep,
  currentProgress,
  setCurrentStep,
  refreshSteps,
  refreshText,
  isActive,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const refreshButtonDisabled = (!refreshSteps || !refreshText)

  const currentNav = navList.find(list => list.step === currentStep)

  return (
    <div
      className={[
        'mz-form-steps-nav',
        isOpen ? 'expanded' : '',
        isActive ? 'active' : '',
        refreshButtonDisabled ? 'mz-form-steps-nav--refresh-disabled' : ''
      ].join(' ')}
    >
      <div className="mz-container">
        <div className="mz-full-width mz-form-steps-nav__inner">

          <div className="mz-form-steps-nav__top">
            {
              !refreshButtonDisabled && (
                <button className="reset mz-form-steps-nav__refresh" onClick={refreshSteps}>
                  <Svg type="refresharrow" size={1.4} colour="grey" />
                  <span className="upper text--grey font-base">{refreshText}</span>
                </button>
              )
            }
            <button className="reset mz-form-steps-nav__active-step" onClick={() => setIsOpen(!isOpen)}>
              <span className="nav nav--sm">{languageController.getCopy('global', 'step')}{currentNav?.step}: {currentNav?.label}</span>
              <Svg type="chevron_small_down" size={0.45} colour="grey" />
            </button>
          </div>

          <div className="mz-form-steps-nav__indicator">
            <div style={{ width: `${(currentStep / navList.length) * 100}%` }}></div>
          </div>

          <div className="mz-form-steps-nav__menu">
            <ul className="reset mz-form-steps-nav__menu-items">
              {
                navList.map(list => {
                  const isActive = (currentStep === list.step)
                  const isDisabled = (list.step > currentProgress)

                  return (
                    <li
                      key={list.step}
                      className={[
                        'mz-form-steps-nav__menu-item',
                        isActive ? 'active' : '',
                        isDisabled ? 'disabled' : ''
                      ].join(' ')}
                    >
                      <button
                        className="reset font-base upper"
                        disabled={isDisabled}
                        onClick={() => {
                          if (list.step !== currentStep) {
                            setCurrentStep(list.step)
                          }
                          setIsOpen(false)
                        }}
                      >
                        {languageController.getCopy('global', 'step')} {list.step} : {list.label}
                      </button>
                    </li>
                  )
                })
              }
            </ul>
          </div>

        </div>
      </div>
    </div>
  )
}

FormStepsNav.propTypes = {
  navList: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
  currentProgress: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  refreshSteps: PropTypes.func,
  refreshText: PropTypes.string,
}

FormStepsNav.defaultTypes = {
  navList: [],
  refreshSteps: undefined,
  refreshText: undefined,
}

export default FormStepsNav